export function autoResize(ref){
    ref.current.style.cssText = 'height:auto';
    ref.current.style.cssText = `height: ${ref.current.scrollHeight}px; max-height: unset`;
}

export const autoResizeElement = (element) => {
    element.style.cssText = 'height:auto';
    element.style.cssText = `height: ${element.scrollHeight}px; max-height: unset`;
};

